export default [
  {
    path: '/education',
    redirect: '/education/regular',
    component: () => import('@/views/education/index.vue'),
    children: [
      {
        path: 'regular',
        name: 'regular',
        component: () => import('@/views/education/regular/index.vue'),
        meta: {
          title: '本科教育',
        },
      },
      {
        path: 'regular/detail',
        name: 'regular/detail',
        component: () => import('@/views/education/regular/detail.vue'),
        meta: {
          title: '本科教育详情',
        },
      },
      {
        path: 'junior',
        name: 'junior',
        component: () => import('@/views/education/junior/index.vue'),
        meta: {
          title: '专科教育',
        },
      },
      {
        path: 'junior/detail',
        name: 'junior/detail',
        component: () => import('@/views/education/junior/detail.vue'),
        meta: {
          title: '专科教育详情',
        },
      },
    ],
  },
];

